// extracted by mini-css-extract-plugin
export default {"listViewContainer":"ProjectView-module__listViewContainer--zICz6","cardViewContainer":"ProjectView-module__cardViewContainer--FIO0q"};